module.exports = __webpack_public_path__ + "static/media/document.505565da.jpg";